import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';

export function getTimeDifference(time: Date) {
  const currentTime = new Date();
  
  const days = differenceInDays(time, currentTime);
  const hours = differenceInHours(time, currentTime) % 24;
  const minutes = differenceInMinutes(time, currentTime) % 60;

  // Formatted string based on the time left
  let timeLine = '';
  if (days > 0) {
    timeLine = `${days} ${days > 1 ? "Days":"Day"}  ${hours} Hours `;
  } else if (hours > 0) {
    timeLine = `${hours} Hours ${minutes} Minutes`;
  } else {
    timeLine = `${minutes} Minutes`;
  }

  return timeLine;
}

